import { Theme } from '@mui/material';

import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  addContainer: {
    color: theme.palette.primary.main,
    position: 'fixed',
    right: '40px',
    bottom: '40px',
    cursor: 'pointer',
    '&:hover': {
      opacity: '.8',
    },
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(),
    background: 'none',
    border: 'none',
  },
  fab: {
    '&:hover': {
      background: theme.palette.primary.main,
    },
  },
}));

export default useStyles;
